import { render, staticRenderFns } from "./All_odds.vue?vue&type=template&id=25026838&scoped=true&"
import script from "./All_odds.vue?vue&type=script&lang=js&"
export * from "./All_odds.vue?vue&type=script&lang=js&"
import style0 from "./All_odds.vue?vue&type=style&index=0&id=25026838&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25026838",
  null
  
)

export default component.exports